import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, shareReplay, switchMap, tap } from 'rxjs/operators';

import { APIService, KPI } from '../../@core/api';
import { StyleService } from './style.service';

@Injectable()
export class InvestmentReasonsService {

  private _investmentReasons$: Observable<KPI.InvestmentReason[]>;
  private investmentReasonsRefresh$ = new BehaviorSubject<void>(null);

  constructor(
    private api: APIService,
    private styleService: StyleService,
  ) { }

  public get investmentReasons$(): Observable<KPI.InvestmentReason[]> {
    if (!this._investmentReasons$) {
      this._investmentReasons$ = this.investmentReasonsRefresh$.pipe(
        switchMap(() => this.api.investments_investment_reasons(null, false)),
        tap((investmentReasons) => {
          investmentReasons.forEach((investmentReason) => {
            this.styleService.setStyles(
              `.investment-reason-${investmentReason.id} .ag-sticky-label, .investment-reason-${investmentReason.id} .ag-header-cell-label`,
              {
                'backgroundColor': StyleService.hexToRGB(investmentReason.background_color, 0.75),
                // 'color': this.styleService.textColorBasedOnBgColor(investmentReason.background_color),
                'alignSelf': 'auto',
                'padding': '4px 10px 5px',
                'borderRadius': '5px',
                'justifyContent': 'center',
                'marginRight': '5px',
                'width': '100%',
              },
            );
          });
        }),
        map((investmentReasons) => investmentReasons.sort((a, b) => a.ordering - b.ordering)),
        shareReplay(1),
      );
    }

    return this._investmentReasons$;
  }

  public refreshInvestmentReasons(): void {
    this.investmentReasonsRefresh$.next();
  }

  public createInvestmentReason(
    investmentReason: Partial<KPI.InvestmentReason>,
  ): Observable<KPI.InvestmentReason> {
    return this.api.investments_investment_reasons_post(investmentReason).pipe(
      tap(() => this.refreshInvestmentReasons()),
    );
  }

  public updateInvestmentReason(
    id: number,
    investmentReason: Partial<KPI.InvestmentReason>,
  ): Observable<KPI.InvestmentReason> {
    return this.api.investments_investment_reasons_patch(id, investmentReason).pipe(
      tap(() => this.refreshInvestmentReasons()),
    );
  }

  public deleteInvestmentReason(
    investmentReasonId: number,
  ): Observable<KPI.InvestmentReason> {
    return this.api.investments_investment_reasons_delete(investmentReasonId).pipe(
      tap(() => this.refreshInvestmentReasons()),
    );
  }

}
